import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { Result } from '@digibricks/core';
import { Message, MessageContent, MessageRole, MessageStatus, MessageTimestamp } from '../../../../core/domain/models';
export var MessageApiMapper = /*#__PURE__*/function () {
  function MessageApiMapper() {
    _classCallCheck(this, MessageApiMapper);
  }

  _createClass(MessageApiMapper, [{
    key: "toDomain",
    value: function toDomain(dto) {
      var contentResult = MessageContent.create(dto.content);

      if (contentResult.isFailure) {
        return Result.fail(contentResult.error);
      }

      var role = dto.role;

      if (!Object.values(MessageRole).includes(role)) {
        return Result.fail("Invalid message role: ".concat(dto.role));
      }

      var createdTimeResult = MessageTimestamp.create(dto.createdAt);

      if (createdTimeResult.isFailure) {
        return Result.fail(createdTimeResult.error);
      }

      var status;

      if (dto.status && !Object.values(MessageStatus).includes(dto.status)) {
        return Result.fail("Invalid message status: ".concat(dto.status));
      }

      status = dto.status;
      return Message.create({
        id: dto.id,
        status: status || MessageStatus.Active,
        conversationId: dto.conversationId,
        role: role,
        content: contentResult.getValue(),
        data: dto.data,
        userId: dto.userId,
        modelId: dto.modelId,
        fileIds: dto.fileIds,
        createdTime: createdTimeResult.getValue(),
        tokenUsed: dto.tokenUsed,
        cost: dto.cost
      });
    }
  }]);

  return MessageApiMapper;
}();